@use '../../../../styles/Colors.scss' as Colors;
@use '../../../../styles/Constants.scss' as Constants;

.job-table{

	&__row {
		&--finished {
			background-color: Colors.$col-greyBackground !important;
			color: Colors.$col-greyFontLight;
		}
	}
}